export enum CommissionSource {
    Agent = 1,
    Client = 2,
}
